<template>
  <!-- <div
    @click="toggle"
    class="csst mdi f-center icon_btn"
    :class="
      $store.getters[toggleKey] === 'on'
        ? 'mdi-fullscreen-exit'
        : 'mdi-fullscreen'
    "
  >
    <div
      class="csst_content"
      style="position: fixed; margin-top: 3.75rem"
      v-if="hasTooltip"
    >
      <span class="keyboardkey pl-2">
        <span class="keyboardkey_key">{{
          $store.getters.hotkeys.study_fullscreen_mode.displayCombination
        }}</span>
        <span
          class="keyboardkey_note text-center"
          v-html="$t('hotkeys.study.to_toggle_fullscreen_mode')"
        >
        </span>
      </span>
    </div>
  </div> -->
  <UnSwitcherNew
    :hasText="false"
    :hasOpener="false"
    translatePath="fullscreen_switch"
    :swKey="toggleKey"
    :style="`${active ? '--uns-opener-clr-back: var(--clr-error);' : ''}`"
  >
    <!-- :style="`${active ? '--uns-opener-clr: var(--clr-error);' : ''}`" -->
    <!-- :style="`${active ? '--uns-opener-clr: var(--clr-yellow);' : ''}`" -->
    <template #menu_after>
      <div class="bt-grey my-1"></div>
      <div
        class="gw_btn no-events gw_btn_text gw_btn_small clr-grey text-medium f-justify-start bt-grey"
        style="--padding: 0.375rem"
      >
        <span class="keyboardkey_key">
          {{ $store.getters.hotkeys.study_fullscreen_mode.displayCombination }}
        </span>
        <span
          class="keyboardkey_note"
          v-html="$t('hotkeys.study.to_switch')"
        ></span>
      </div>
    </template>
  </UnSwitcherNew>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'

export default {
  name: 'StudyFullscreenSwitcher',
  components: {
    UnSwitcherNew,
  },
  props: {
    toggleKey: { default: 'sw_study_range_fullscreen' },
    hasTooltip: { type: Boolean, default: true },
    persist: Boolean,
    hotkeyActive: Boolean,
  },
  methods: {
    toggle() {
      this.$store.dispatch('switchers_set_item', {
        key: this.toggleKey,
        item: { payload: this.$store.getters[this.toggleKey] === 'on' ? 'off' : 'on' },
      })
      // this.$store.state.solutions[this.toggleKey] = !this.$store.state.solutions[this.toggleKey]
      // if (this.persist) {
      //   localStorage.setItem(this.toggleKey, this.$store.state.solutions[this.toggleKey])
      // }
      // console.log('toggle', this.toggleKey, this.$store.getters[this.toggleKey])
    },
  },
  computed: {
    active() {
      return this.$store.getters[this.toggleKey] === 'on'
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
  },
  watch: {
    hotkeysPressed(keys) {
      if (!this.hotkeyActive) return
      if (!keys) return
      const hotkeyActions = {
        toggleFulscreen: {
          keys: this.hotkeys.study_fullscreen_mode.keyCombination,
          fn: this.toggle,
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>
<style lang="scss" scoped>
.fscr-container {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  align-items: center;
  justify-content: center;
}
.is-transparent {
  .copy-btn {
    background-color: transparent !important;
  }
}
</style>
